import firebase from 'firebase/app';
import 'firebase/firestore';
import "firebase/storage";
import 'firebase/auth';

// import { storage } from '../main.js'

export const checklist = {

    data() {
        return {
            checklists: [],
            checklists_listener: [],
            singleChecklist: {},
            checklistStrucuture: {},
            allChecklistStrucutre: {},
            allChecklistTypes: [],
        }
    },
    methods: {
        clearchecklistData() {
            console.log("clearchecklistData")
            this.checklists = [];
            this.singleChecklist = {};
            for (let l of this.checklists_listener) {
                l();
            }
        },
        uuidv4() {
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        async upload_image(visit_id, checklist_id, image_data) {
            console.log(image_data)
            if (image_data === "") return ""
            console.log("upload_image: ", visit_id + "/" + checklist_id + "/" + this.uuidv4() + ".jpg")
            let ref = firebase.storage().ref(visit_id + "/" + checklist_id + "/" + this.uuidv4() + ".jpg");
            await ref.putString(image_data, "data_url")
            let url = await ref.getDownloadURL()
            return url
        },
        deleteSingleChecklist(visit_id, checklist_id) {
            firebase.firestore().collection("visits").doc(visit_id).collection("checklists").doc(checklist_id).delete()
        },
        startAllChecklistStrucutre(market_owner = "rewenorth") {
            console.log("startAllChecklistStrucutre")
            console.log("Only rewenorth works for the moment")
            let vm = this;
            let listenr = firebase.firestore().collection("structure_" + market_owner)
                .onSnapshot(snapshot => {
                    vm.allChecklistStrucutre = {};
                    snapshot.forEach((c) => {
                        let ch = c.data();
                        vm.allChecklistStrucutre[c.id] = ch;
                    })
                })
            this.checklists_listener.push(listenr)
        },
        startChecklistStrucutre(component_type, market_owner = "rewenorth") {
            console.log("startChecklistStrucutre")
            console.log("Only rewenorth works for the moment")
            let vm = this;
            let listener = firebase.firestore().collection("structure_" + market_owner).doc(component_type)
                .onSnapshot(snapshot => {
                    vm.checklistStrucuture = snapshot.data()
                })
            this.checklists_listener.push(listener)
        },
        startSingleChecklistListener(visit_id, checklist_id) {
            console.log("startSingleChecklistListener")
            let vm = this;
            let listenr = firebase.firestore().collection("visits").doc(visit_id).collection("checklists").doc(checklist_id)
                .onSnapshot(snapshot => {
                    vm.singleChecklist = snapshot.data()
                })
            this.checklists_listener.push(listenr)
        },
        startChecklistListener(visit_id) {
            console.log("startChecklistListener")
            let vm = this;
            let listenr = firebase.firestore().collection("visits").doc(visit_id).collection("checklists")
                .onSnapshot(snapshot => {
                    vm.checklists = [];
                    snapshot.forEach((c) => {
                        let ch = c.data();
                        ch["checklist_id"] = c.id;
                        vm.checklists.push(ch)
                    })
                })
            this.checklists_listener.push(listenr)
        },
        async updateChecklist(checklist_id, visit_id, data) {
            await firebase.firestore().collection("visits").doc(visit_id).collection("checklists").doc(checklist_id).update(data);
        },
        async createChecklist(visit_id, market_name, type, data = false) {
            let user = this.getUser();
            let og_data = {
                type: type,
                visit_id: visit_id,
                created_by: user.uid,
                store_name_app: market_name

            }
            if (data) {
                og_data = { ...og_data, ...data }
            }
            let newCheck = await firebase.firestore().collection("visits").doc(visit_id).collection("checklists").add(og_data);
            await firebase.firestore().collection("visits").doc(visit_id).collection("checklists").doc(newCheck.id).update({ checklist_id: newCheck.id })
            return newCheck.id
        },
    }
}